import React, { Fragment } from 'react';
import About from '../../components/about/about';
import Footer from '../../components/footer/Footer';
import Hero from '../../components/hero/hero';
import Scrollbar from '../../components/scrollbar/scrollbar';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import abimg from '../../images/about.png'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Logo from '../../images/logo2.png'

const HomePage = () => {
    return (
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
            <Hero />
            <About abimg={abimg} />
            <ServiceSection />
            <Testimonial />
            <PartnerSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;